import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import userPresenter from "../../../presenter/user/AllUser";
import { Link } from "react-router-dom";

function AllUserDeleted() {
  const [usersDeletedHtml, setALlUsersDeletedHtml] = useState("");
  useEffect(() => {
    getUsersDeleted();
  }, []);
  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  async function getUsersDeleted() {
    const headersRequest = getHeaderForRequset();

    const result = await httpService.getRequest(
      process.env.REACT_APP_DOMAIN_API + "/v1/user/deleted-user",
      headersRequest
    );

    setALlUsersDeletedHtml(generateHtmlTagUsersDeleted(result.data.data));
  }

  const generateHtmlTagUsersDeleted = (users) => {
    users = userPresenter.allUserTabel(users);
    let resultHtml;
    resultHtml = users.map((user, index) => {
      return (
        <tr key={index}>
          <td>{helperNumber.toPersianNum(index + 1)}</td>

          <td>{helperNumber.toPersianNum(user.usr_id)}</td>
          <td dir="ltr">{user.usr_mobile}</td>
          <td>{user.persian_role_name}</td>
          <td>{user.firstname}</td>
          <td>{user.lastname}</td>
          <td>{user.usr_last_login_at}</td>
          <td>{user.usr_created_at}</td>
          <td>
            <div className="text-nowrap">
              <span className="pl-2">
                <Link
                  href="# "
                  className="btn btn-outline-info  "
                  to={`/user/show-info-user/${user.usr_id} `}
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
    return resultHtml;
  };

  return (
    <>
      <Sidebar openItem="users" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">کاربران حذف شده</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-dark tbl-all-users ">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره کاربری</td>
                      <td>شماره موبایل</td>
                      <td>نقش</td>
                      <td>نام</td>
                      <td>نام خانوداگی</td>
                      <td>تاریخ آخرین ورود</td>
                      <td>تاریخ عضویت</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>

                  <tbody>{usersDeletedHtml}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllUserDeleted;
